import classNames from "classnames";
import { useEffect } from "react";
import { BiSolidReport } from "react-icons/bi";
import { FaFileSignature, FaLeaf } from "react-icons/fa";
import { MdCloudDone } from "react-icons/md";
import { Card, CardBody, Col, Row } from "reactstrap";
import ErrorBoundary from "src/components/ErrorBoundary/ErrorBoundary";
import useLazyFetch from "src/hooks/useLazyFetch";
import { AET_DASHBOARD_SUMMARY } from "src/redux/config/links";

const AETSummary = ({
  loadSummary,
  setLoadSummary,
}: {
  loadSummary: boolean;
  setLoadSummary: (value: boolean) => void;
}) => {
  const [onGetSummary, { data }] = useLazyFetch({
    url: AET_DASHBOARD_SUMMARY,
    method: "POST",
  });

  useEffect(() => {
    if (loadSummary) {
      setLoadSummary(false);
      onGetSummary({
        body: {},
      });
    }
  }, [loadSummary, onGetSummary, setLoadSummary]);
  return (
    <>
      <Row>
        <Col md={3} xs={12}>
          <ErrorBoundary>
            <Card>
              <CardBody>
                <div
                  className={classNames(
                    "text-white",
                    "p-3",
                    "font-1xl mr-3 float-left d-flex align-items-center justify-content-center"
                  )}
                  style={{ color: "#fff", background: "#0085FF" }}
                >
                  <MdCloudDone size={25} />
                </div>
                <div
                  className={classNames("h5 mb-0", "mt-2")}
                  style={{ color: "#0085FF" }}
                >
                  {(!!data ? data.result.carbon_total.total : 0).toFixed(2)}{" "}
                  tCO2e
                </div>
                <div className="text-muted text-uppercase font-weight-bold font-xs">
                  Total Carbon Emission{" "}
                  {!!data
                    ? data.result.carbon_total.calculated_do !==
                      data.result.carbon_total.total_do
                      ? `(${data.result.carbon_total.calculated_do} of ${data.result.carbon_total.total_do} calculated)`
                      : null
                    : null}
                </div>
              </CardBody>
            </Card>
          </ErrorBoundary>
        </Col>
        <Col md={3} xs={12}>
          <ErrorBoundary>
            <Card>
              <CardBody>
                <div
                  className={classNames(
                    "text-white",
                    "p-3",
                    "font-1xl mr-3 float-left d-flex align-items-center justify-content-center"
                  )}
                  style={{ color: "#fff", background: "#E43D3D" }}
                >
                  <BiSolidReport size={25} />
                </div>
                <div
                  className={classNames("h5 mb-0", "mt-2")}
                  style={{ color: "#E43D3D" }}
                >
                  {!!data ? data.result.wo_total : 0} delivery
                </div>
                <div className="text-muted text-uppercase font-weight-bold font-xs">
                  Total Work Order
                </div>
              </CardBody>
            </Card>
          </ErrorBoundary>
        </Col>
        <Col md={3} xs={12}>
          <ErrorBoundary>
            <Card>
              <CardBody>
                <div
                  className={classNames(
                    "text-white",
                    "p-3",
                    "font-1xl mr-3 float-left d-flex align-items-center justify-content-center"
                  )}
                  style={{ color: "#fff", background: "#F98600" }}
                >
                  <FaFileSignature size={25} />
                </div>
                <div
                  className={classNames("h5 mb-0", "mt-2")}
                  style={{ color: "#F98600" }}
                >
                  {!!data ? data.result.outbound_total : 0} pce/s
                </div>
                <div className="text-muted text-uppercase font-weight-bold font-xs">
                  Total Outbound Items
                </div>
              </CardBody>
            </Card>
          </ErrorBoundary>
        </Col>
        <Col md={3} xs={12}>
          <ErrorBoundary>
            <Card>
              <CardBody>
                <div
                  className={classNames(
                    "text-white",
                    "p-3",
                    "font-1xl mr-3 float-left d-flex align-items-center justify-content-center"
                  )}
                  style={{ color: "#fff", background: "#00952A" }}
                >
                  <FaLeaf size={25} />
                </div>
                <div
                  className={classNames("h5 mb-0", "mt-2")}
                  style={{ color: "#00952A" }}
                >
                  {(!!data
                    ? data.result.carbon_total.total / data.result.wo_total
                    : 0
                  ).toFixed(2)}{" "}
                  kgCO2e/delivery or{" "}
                  {!!data && data.result.outbound_total!==0?(!!data
                    ? data.result.carbon_total.total /
                      data.result.outbound_total
                    : 0
                  ).toFixed(2):0}{" "}
                  kgCO2e/pce
                </div>
                <div className="text-muted text-uppercase font-weight-bold font-xs">
                  Carbon Intensity
                </div>
              </CardBody>
            </Card>
          </ErrorBoundary>
        </Col>
      </Row>
    </>
  );
};

export default AETSummary;
